import { NgStyle } from '@angular/common'
import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    EventEmitter,
    inject,
    Input,
    Output,
    ChangeDetectionStrategy,
} from '@angular/core'

@Component({
    selector: 'app-timer',
    imports: [
        NgStyle,
    ],
    templateUrl: './timer.component.html',
    styleUrl: './timer.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: true,
})
export class TimerComponent implements AfterViewInit {

    /**
     * Represents the length of the animation in ms.
     */
    @Input()
    public length: number = 10000

    @Output()
    public done = new EventEmitter<Date>()
    public cd = inject(ChangeDetectorRef)
    public progressBarState = 'start'

    public time: number

    public ngAfterViewInit(): void {
        this.progressBarState = 'end'
        this.time = Math.ceil(this.length / 1000)
        this.cd.detectChanges()

        const interval = setInterval(() => {
            this.time--
        }, 1000)

        setTimeout(() => {
            clearInterval(interval)
            this.done.emit(new Date())
        }, this.length)
    }

}
